// let carousels = document.querySelectorAll('.custom-carousel');

// carousels.forEach((el) => {
//   new Flickity(el, {
//     //options
//     cellAlign: 'left',
//     wrapAround: false,
//     // autoPlay: 5000
//     // autoPlay: 2000,
//     fullscreen: true,
//     contain: true,
//     pageDots: true,
//     prevNextButtons: true,
//   })
// })

// REMOVED MEDIA QUERY EVENT LISTENER
// Function to initialize carousels
function initializeCarousels(cellAlign, contain, freeScroll) {
  let carousels = document.querySelectorAll(".custom-carousel");

  carousels.forEach((el, index) => {
    let flkty = new Flickity(el, {
      cellAlign: cellAlign,
      wrapAround: false,
      contain: contain,
      fullscreen: true,
      pageDots: true,
      prevNextButtons: true,
      freeScroll: freeScroll,
    });

    console.log(`Carousel ${index + 1} has ${flkty.slides.length} slides`);

    // Get the next and previous buttons
    let nextButton = el.querySelector(".flickity-button.next");
    let prevButton = el.querySelector(".flickity-button.previous");

    // Log if buttons are found
    // console.log(`Next button found: ${!!nextButton}, Prev button found: ${!!prevButton}`);

    // Function to calculate visible slides
    function getVisibleSlides() {
      let visibleWidth = flkty.viewport.clientWidth;
      let cellWidth = flkty.cells[0].size.width;
      return Math.floor(visibleWidth / cellWidth);
    }

    // Update button states on select
    flkty.on("select", updateButtonStates);

    // Initial check
    updateButtonStates();

    function updateButtonStates() {
      const totalSlides = flkty.slides.length;
      const visibleSlides = getVisibleSlides();
      const maxIndex = totalSlides - visibleSlides;

      if (prevButton) {
        prevButton.classList.toggle("disabled", flkty.selectedIndex === 0);
        // console.log(`Carousel ${index + 1}: ${flkty.selectedIndex === 0 ? 'Added' : 'Removed'} 'disabled' class to/from prev button`);
      }

      if (nextButton) {
        nextButton.classList.toggle(
          "disabled",
          flkty.selectedIndex >= maxIndex
        );
        // console.log(`Carousel ${index + 1}: ${flkty.selectedIndex >= maxIndex ? 'Added' : 'Removed'} 'disabled' class to/from next button`);
      }

      // For debugging
      // console.log(`Carousel ${index + 1} current index: ${flkty.selectedIndex}, Total slides: ${totalSlides}, Visible slides: ${visibleSlides}, Max index: ${maxIndex}`);
    }
  });
}

// Function to run on page load
function initializeOnLoad() {
  const screenWidth = window.innerWidth;
  if (screenWidth >= 1020) {
    console.log("Screen size is over 768px");
    initializeCarousels("left", true, false);
  } else {
    console.log("Screen size is less than 768px");
    initializeCarousels("center", false, true);
  }
}

// Run the initialization function when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", initializeOnLoad);
